import { Box } from '@mui/material';

import ControlBar from '../../meeting/controlBar';
import MeetingNotification from '../../meeting/notification';
import MeetingSidebar from '../../meeting/sidebar';
import UserVideoTileGrid from '../../meeting/userVideoGrid';

function VideoCallLayout() {
  return (
    <>
      <MeetingNotification />
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            flexGrow: 1,
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
            }}
          >
            <UserVideoTileGrid />
          </Box>
          <Box>
            <ControlBar />
          </Box>
        </Box>
        <Box
          sx={{
            position: {
              xs: 'absolute',
              md: 'initial',
            },
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          <MeetingSidebar />
        </Box>
      </Box>
    </>
  );
}

export default VideoCallLayout;
